import React, { useEffect, useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/apiClient";

const ST = { COMPLETED: "text-emerald-400", MERCHANT_REGISTERED: "text-sky-300", INVALID: "text-rose-400", BLOCKED: "text-rose-400" };

export default function Referrals() {
  const [d, setD] = useState(null);
  const [status, setStatus] = useState("");
  const load = () => {
    const p = status ? { status } : {};
    api.get("/admin/referrals", { params: p }).then((r) => setD(r.data)).catch(() => toast.error("Failed"));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);
  if (!d) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-emerald-500" /></div>;
  const a = d.analytics;
  return (
    <div className="space-y-5" data-testid="admin-referrals">
      <div className="flex items-center gap-2"><Gift className="h-5 w-5 text-emerald-400" /><h1 className="font-heading text-2xl font-bold">Referrals</h1></div>
      <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-5">
        <Card label="Total" value={a.total} testid="ref-total" />
        <Card label="Completed" value={a.completed} accent testid="ref-completed" />
        <Card label="First rewards" value={`${a.first_count} · ${a.first_cost_display}`} testid="ref-first" />
        <Card label="Renewal rewards" value={`${a.renewal_count} · ${a.renewal_cost_display}`} testid="ref-renewal" />
        <Card label="Total cost" value={a.total_cost_display} accent testid="ref-cost" />
      </div>
      <select data-testid="ref-filter-status" value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-full border border-slate-700 bg-slate-900 px-3 py-1.5 text-sm">
        <option value="">All statuses</option><option value="COMPLETED">Completed</option><option value="MERCHANT_REGISTERED">Registered</option><option value="INVALID">Invalid</option><option value="BLOCKED">Blocked</option>
      </select>
      <div className="ledger-card overflow-hidden rounded-2xl">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="referrals-table">
            <thead className="bg-slate-900/50 font-mono text-xs uppercase tracking-wider text-slate-500"><tr><th className="p-4 text-left">Customer</th><th className="p-4 text-left">Merchant</th><th className="p-4 text-left">Code</th><th className="p-4 text-left">Status</th><th className="p-4 text-left">Fraud</th><th className="p-4 text-right">First</th><th className="p-4 text-right">Renewals</th></tr></thead>
            <tbody>
              {d.referrals.map((r) => (
                <tr key={r.referralId} className="border-t border-slate-800/60">
                  <td className="p-4">{r.customer_name}</td>
                  <td className="p-4">{r.merchant_name}</td>
                  <td className="p-4 font-mono text-xs text-emerald-400">{r.referralCode}</td>
                  <td className={`p-4 font-mono text-xs ${ST[r.status] || ""}`}>{r.status}</td>
                  <td className={`p-4 font-mono text-xs ${r.fraudStatus && r.fraudStatus !== "CLEAR" ? "text-rose-400" : "text-slate-500"}`}>{r.fraudStatus}</td>
                  <td className="p-4 text-right font-mono">{r.first_reward_display}</td>
                  <td className="p-4 text-right font-mono text-slate-400">{r.renewalCount || 0}</td>
                </tr>
              ))}
              {d.referrals.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-slate-500">No referrals yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
function Card({ label, value, accent, testid }) {
  return <div className="ledger-card rounded-2xl p-4" data-testid={testid}><p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{label}</p><p className={`mt-1 font-heading text-lg font-bold ${accent ? "text-emerald-400" : "text-slate-100"}`}>{value}</p></div>;
}
